import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

export default new createVuetify({
  components,
  directives,
  icons: {
    iconfont: 'mdi',
  },
})
